// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiStyles.js
//  WikiStyles
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

// Styles du contenu rendu (le backend renvoie du HTML déjà assaini)
export function WikiStyles() {
  return (
    <style>{`
      .wiki-doc { color:${THEME.text}; font-size:14px; line-height:1.65; }
      .wiki-doc .wiki-h1,.wiki-doc .wiki-h2 { color:${THEME.gold}; font-size:18px; margin:22px 0 8px; }
      .wiki-doc .wiki-h3 { color:${THEME.text}; font-size:15px; margin:18px 0 6px; }
      .wiki-doc .wiki-h4,.wiki-doc .wiki-h5,.wiki-doc .wiki-h6 { color:${THEME.textMuted}; font-size:14px; margin:14px 0 4px; }
      .wiki-doc .wiki-p { margin:8px 0; }
      .wiki-doc .wiki-ul,.wiki-doc .wiki-ol { margin:8px 0; padding-left:22px; }
      .wiki-doc li { margin:4px 0; }
      .wiki-doc code { background:${THEME.surface}; border:1px solid ${THEME.border}; border-radius:4px; padding:1px 5px; font-size:12.5px; font-family:'Courier New',monospace; }
      .wiki-doc .wiki-pre { background:#0D1117; border:1px solid ${THEME.border}; border-radius:8px; padding:12px; overflow-x:auto; }
      .wiki-doc .wiki-pre code { background:none; border:none; padding:0; font-size:12.5px; }
      .wiki-doc .wiki-quote { border-left:3px solid ${THEME.purple}; margin:10px 0; padding:4px 14px; color:${THEME.textMuted}; }
      .wiki-doc .wiki-hr { border:none; border-top:1px solid ${THEME.border}; margin:18px 0; }
      .wiki-doc .wiki-table { border-collapse:collapse; width:100%; margin:12px 0; font-size:13px; display:block; overflow-x:auto; }
      .wiki-doc .wiki-table th { background:${THEME.surface}; color:${THEME.textMuted}; text-align:left; font-size:11px; text-transform:uppercase; letter-spacing:.4px; }
      .wiki-doc .wiki-table th,.wiki-doc .wiki-table td { border:1px solid ${THEME.border}; padding:7px 10px; }
      .wiki-doc .wiki-img { max-width:100%; border-radius:8px; border:1px solid ${THEME.border}; margin:8px 0; }
      .wiki-doc .wiki-lien { color:${THEME.accent}; }
      .wiki-doc .wiki-chip { display:inline-flex; align-items:center; gap:4px; border-radius:6px; padding:1px 8px; font-size:12.5px; font-weight:600; cursor:pointer; margin:0 2px; background:${THEME.purpleDim}; color:${THEME.purple}; border:1px solid ${THEME.purple}; }
      .wiki-doc .wiki-chip-ticket { background:${THEME.goldDim}; color:${THEME.gold}; border-color:${THEME.gold}; }
      .wiki-doc .wiki-chip-joueur { background:${THEME.accentDim}; color:${THEME.accent}; border-color:${THEME.accent}; }
      .wiki-doc .wiki-chip-tache  { background:${THEME.emeraldDim}; color:${THEME.emerald}; border-color:${THEME.emerald}; }
      .wiki-doc .wiki-chip-doc    { background:${THEME.surface}; color:${THEME.textMuted}; border-color:${THEME.border}; }
      .wiki-doc .wiki-chip-mort   { background:transparent; color:${THEME.textDim}; border:1px dashed ${THEME.border}; text-decoration:line-through; cursor:default; }
    `}</style>
  );
}
